import { observer } from 'mobx-react';
import React from 'react';

import { useFormikContext } from 'formik';
import store from 'store';

import SelectField from '@common/components/Form/SelectField';

function AppointmentsAcademicSelectPart({ locationMeet }: any) {
	const { values, submitForm } = useFormikContext<any>();

	return (
		<>
			<SelectField
				label="Location"
				name="location_id"
				options={store.profile.serviceLocations.map((location) => ({
					label: location.name,
					value: location.id,
				}))}
				onChange={submitForm}
				sx={{ background: '#fff', boxShadow: '0px 0px 30px 0px rgba(130, 125, 131, 0.15)' }}
				MenuProps={{
					PaperProps: {
						style: {
							background: '#fff',
						},
					},
				}}
			/>
			<SelectField
				label="Group"
				name="group_id"
				options={store.profile.student?.groups
					.filter(
						(group: any) =>
							group.location.id === values.location_id &&
							group.service_id === store.services.current.id,
					)
					.map((location: any) => ({
						label: location.name,
						value: location.id,
					}))}
				onChange={submitForm}
				sx={{ background: '#fff', boxShadow: '0px 0px 30px 0px rgba(130, 125, 131, 0.15)' }}
				MenuProps={{
					PaperProps: {
						style: {
							background: '#fff',
						},
					},
				}}
			/>
			<SelectField
				label="Teacher"
				name="teacher_id"
				options={locationMeet.teachers.map((teacher: any) => ({
					label: teacher.fullName,
					value: teacher.id,
				}))}
				onChange={submitForm}
				sx={{ background: '#fff', boxShadow: '0px 0px 30px 0px rgba(130, 125, 131, 0.15)' }}
				MenuProps={{
					PaperProps: {
						style: {
							background: '#fff',
						},
					},
				}}
			/>
		</>
	);
}

export default observer(AppointmentsAcademicSelectPart);
